<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<!--<div
  class="view-with-static-right-sidebar ps"
  [ngClass]="{ 'sidebar-opened': activitiesService.isOpened }"
  [perfectScrollbar]
>-->

<div class="venue-view-wrapper relative">
  <div class="top">
    <div class="preview-header d-flex justify-content-between">
      <div class="preview-title-wrapper">
        <span class="icon-holder"><i class="far fa-map-marked"></i></span>

        <span class="title">
          {{ venue?.name }}
          <app-active-indicator [active]="venue?.active"></app-active-indicator>
        </span>

        <span class="additional-info">
          <span class="sub-title">{{ 'VENUES.VENUES_VIEW.CITY' | translate }}</span>
          <span class="value">{{ venue?.city?.name }}, {{ venue?.city?.country?.name }}</span>

          <span class="sub-title ms-1">{{ 'VENUES.VENUES_VIEW.ADDRESS' | translate }}</span>
          <span class="value">{{ venue?.address }}</span>
        </span>
      </div>
      <div class="preview-btns-wrapper">
        <button
          *ngIf="accessService.hasAccess([UserRoleType.LEAD_GENERATION], ['venues.show'])"
          type="button"
          class="btn btn-sm btn-success"
          (click)="edit()"
        >
          {{ 'VENUES.VENUES_VIEW.EDIT_VENUE_BTN' | translate }}
        </button>

        <button
          *ngIf="accessService.hasAccess([UserRoleType.LEAD_GENERATION], ['venues.store'])"
          type="button"
          class="btn btn-sm btn-info"
          (click)="add()"
        >
          {{ 'VENUES.VENUES_VIEW.NEW_VENUE_BTN' | translate }}
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="d-flex flex-wrap">
          <div class="section">
            <div class="section-title mt-2 mb-1">{{ 'VENUES.VENUES_VIEW.GENERAL' | translate }}</div>

            <div *ngIf="venue?.lat">
              <div class="sub-title">{{ 'VENUES.VENUES_VIEW.LAT' | translate }}</div>
              <div class="value">
                {{ venue.lat }}
              </div>
            </div>

            <div *ngIf="venue?.long">
              <div class="sub-title">{{ 'VENUES.VENUES_VIEW.LONG' | translate }}</div>
              <div class="value">
                {{ venue.long }}
              </div>
            </div>

            <div *ngIf="venue?.founded_at">
              <div class="sub-title">{{ 'VENUES.VENUES_VIEW.FOUNDED_AT' | translate }}</div>
              <div class="value">
                {{ venue.founded_at }}
              </div>
            </div>

            <div *ngIf="venue?.rooms_count">
              <div class="sub-title">{{ 'VENUES.VENUES_VIEW.ROOMS_COUNT' | translate }}</div>
              <div class="value">
                {{ venue.rooms_count }}
              </div>
            </div>

            <div *ngIf="venue?.visitors_per_year">
              <div class="sub-title">{{ 'VENUES.VENUES_VIEW.VISITORS_PER_YEAR' | translate }}</div>
              <div class="value">
                {{ venue.visitors_per_year }}
              </div>
            </div>

            <div *ngIf="venue?.area">
              <div class="sub-title">{{ 'VENUES.VENUES_VIEW.AREA' | translate }}</div>
              <div class="value">
                {{ venue.area }}
              </div>
            </div>

            <div *ngIf="venue?.distance_to_center">
              <div class="sub-title">{{ 'VENUES.VENUES_VIEW.DISTANCE_TO_CENTER' | translate }}</div>
              <div class="value">
                {{ venue.distance_to_center }}
              </div>
            </div>

            <div *ngIf="venue?.distance_to_airport">
              <div class="sub-title">{{ 'VENUES.VENUES_VIEW.DISTANCE_TO_AIRPORT' | translate }}</div>
              <div class="value">
                {{ venue.distance_to_airport }}
              </div>
            </div>

            <div *ngIf="venue?.distance_to_tr_point">
              <div class="sub-title">{{ 'VENUES.VENUES_VIEW.DISTANCE_TO_TR_POINT' | translate }}</div>
              <div class="value">
                {{ venue.distance_to_tr_point }}
              </div>
            </div>

            <div *ngIf="venue?.distance_to_tr_point_name">
              <div class="sub-title">{{ 'VENUES.VENUES_VIEW.DISTANCE_TO_TR_POINT_NAME' | translate }}</div>
              <div class="value sm">
                {{ venue.distance_to_tr_point_name }}
              </div>
            </div>
          </div>

          <div class="section" *ngIf="venue?.note">
            <div class="section-title mt-2 mb-1">{{ 'VENUES.VENUES_VIEW.NOTE' | translate }}</div>
            <div class="value">
              {{ venue?.note }}
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <google-map
          class="agm-map"
          height="260px"
          width="100%"
          [center]="{
            lat: number(venue.lat),
            lng: number(venue.long),}
          "
          *ngIf="venue && venue.lat && venue.long"
          >
          <map-marker
            [position]="{
            lat: number(venue.lat),
            lng: number(venue.long),}
            "
            [options]="{draggable: false }"
            [icon]="'assets/map_marker.png'"
          >
            <map-info-window class="agm-infowindow">{{ venue.name }}</map-info-window>
          </map-marker>
        </google-map>
      </div>
    </div>
  </div>

  <div class="title2">
    {{ 'VENUES.VENUES_VIEW.EVENTS' | translate }}
  </div>

  <kendo-grid
    [data]="eventsData"
    [pageSize]="eventsRequestsResponse?.meta.per_page"
    [sortable]="true"
    [filterable]="true"
    [filter]="eventsState?.filter"
    [sort]="eventsState?.sort"
    [skip]="eventsState?.skip"
    [pageable]="true"
    (dataStateChange)="loadEventsDataTable($event)"
  >
    <kendo-grid-column
      [width]="70"
      class="text-center"
      headerClass="text-center"
      title="{{ 'VENUES.VENUES_VIEW.NUMBER' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ rowIndex + 1 }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="id"
      title="{{ 'VENUES.VENUES_VIEW.ID' | translate }}"
      filter="numeric"
      [width]="150"
    ></kendo-grid-column>

    <kendo-grid-column field="name" title="{{ 'VENUES.VENUES_VIEW.EDITION_NAME' | translate }}" filter="text">
      <ng-template kendoGridCellTemplate let-dataItem>
        <a [routerLink]="['/events/view']" [queryParams]="{ id: dataItem.id }">
          {{ dataItem.formattedName }}
        </a>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="type.value" title="{{ 'VENUES.VENUES_VIEW.TYPE' | translate }}" filter="text">
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-type-badge [type]="dataItem.type"></app-type-badge>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="date_from"
      title="{{ 'VENUES.VENUES_VIEW.DATE_FROM' | translate }}"
      filter="date"
      format="{0:dd/MM/yyyy}"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.date_from | date : env.pipeDateFormat }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="date_to"
      title="{{ 'VENUES.VENUES_VIEW.DATE_TO' | translate }}"
      filter="date"
      format="{0:dd/MM/yyyy}"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.date_to | date : env.pipeDateFormat }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'VENUES.VENUES_VIEW.ACTIONS' | translate }}"
      [width]="100"
      [class]="'text-center'"
      [includeInChooser]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-edit-button
          *ngIf="accessService.hasAccess([UserRoleType.ADMINISTRATOR], ['events.show'])"
          (click)="editEvent(dataItem)"
        >
        </app-edit-button>

        <app-seo-button
          (click)="editEventSeo(dataItem)"
          *ngIf="AuthenticationService.checkPermission('events.translations')"
        ></app-seo-button>

        <app-delete-button
          *ngIf="accessService.hasAccess([UserRoleType.ADMINISTRATOR], ['events.destroy'])"
          [swal]="{}"
          (confirm)="deleteEvent(dataItem)"
        >
        </app-delete-button>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</div>
